import React from 'react';
import classNames from 'classnames';

import { useIsMobile } from '../../../../hooks';

import styles from './SkeletonLoaderRow.module.scss';

const SkeletonLoaderRow = () => {
  const isMobile = useIsMobile();
  return (
    <tr className={styles.wrapperSkeletonLoaderRow}>
      <td>
        <div className={styles.skeletonLoaderLogoAndName}>
          <div className={styles.logoWrapper}>
            <div className={styles.logo} />
          </div>
          <div>
            <div className={styles.symbol} />
            <div className={styles.name} />
          </div>
        </div>
      </td>
      { isMobile ? (
        <>
          <td>
            <div className={styles.rowItem} />
            <div className={styles.rowItemEmpty} />
          </td>
          <td>
            <div className={styles.daily}>
              <div>
                <div className={classNames(styles.rowItem, styles.bottomMargin)} />
                <div className={styles.rowItem} />
              </div>
            </div>
          </td>
        </>
      ) : (
        <>
          <td>
            <div className={styles.rowItem} />
          </td>
          <td>
            <div className={styles.rowItem} />
          </td>
          <td>
            <div className={styles.rowItem} />
          </td>
          <td>
            <div className={styles.rowItem} />
          </td>
        </>
      )}
    </tr>
  );
};

export default SkeletonLoaderRow;
